import { Directive, Output, EventEmitter, Input, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime, filter, distinctUntilChanged } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[novaTypeahead]',
    standalone: true
})
export class TypeaheadDirective implements OnInit, OnDestroy {
    private subscription: Subscription;
    @Input() delay = 500;
    @Input('novaTypeahead') formControl: UntypedFormControl;
    @Output() textChange = new EventEmitter<string>();

    ngOnInit() {
        if (!this.formControl) {
            console.warn('Instantiated a [novaTypeahead] directive but no form control assigned!');
            return;
        }

        this.subscription = this.formControl.valueChanges
            .pipe(
                debounceTime(this.delay), //wait until user stops typing to send request
                filter((newVal) => newVal.length > 1), //exclude search terms less than 2 characters
                distinctUntilChanged() //don't send request if the value hasn't actually changed
            )
            .subscribe((text) => {
                this.textChange.emit(text);
            });
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
